module.exports = __webpack_public_path__ + "static/media/gc-akrotiri.96f3ad60.png";